<div class="row-filter--container row-filter-scroll" *ngIf="visible">
  <div class="d-flex align-items-baseline gap-20">
    <h5 class="font-weight-bold uppercase m-0">Filter By:</h5>
    <ul class="row-products-list__filters mb-0 d-flex align-items-start">
      <ng-container *ngFor="let filter of sortedFiltersGroup">
        <li *ngIf="isVisible(filter)" class="products-list__filters__section relative-position">
          <row-filter-group [filter]="filter"
                        [filterItemHeight]="filterItemMaxHeight"
                        (toggledFilter)="toggleDropdown($event)"
                        (changedFilter)="onFilterChanged($event)"
                        (updatedFilter)="updateFilters($event)"></row-filter-group>
        </li>
      </ng-container>
    </ul>
  </div>
</div>

